import { ITranslations } from 'types/common';
import { BrandCataloguesPageFields } from './types';
import en from 'translations/en/brandCatalogues.json';
import pl from 'translations/pl/brandCatalogues.json';
import sl from 'translations/sl/brandCatalogues.json';

export const brandCataloguesTranslations: ITranslations<BrandCataloguesPageFields> = {
  name: 'brandCatalogues',
  en,
  pl,
  sl,
};
